import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Step1ContactInfo from './Step1_ContactInfo';
import Step2MovingDetails from './Step2_MovingDetails';
import Step3Inventory from './Step3_Inventory';
import Step4Extras from './Step4_Extras';
import Button from '../../common/Button';
import { useQuoteCalculator } from '../../../hooks/useQuoteCalculator';
import { sendQuoteEmail } from '../../../api/mailer';

export default function QuoteForm() {
  const { register, handleSubmit, formState: { errors }, watch, reset } = useForm({
    defaultValues: { from: {}, to: {}, inventory: {}, extras: {} }
  });
  const [step, setStep] = useState(1);

  const dataForCalc = watch();
  const price = useQuoteCalculator(dataForCalc);

  const onSubmit = async (values) => {
    await sendQuoteEmail({ ...values, price });
    alert('Poslato! Hvala.');
    reset();
    setStep(1);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <p><strong>Informativna cena:</strong> {price} RSD</p>
  {step === 1 && <Step1ContactInfo register={register} errors={errors} />}
  {step === 2 && <Step2MovingDetails register={register} errors={errors} />}
  {step === 3 && <Step3Inventory register={register} watch={watch} />}
  {step === 4 && <Step4Extras register={register} />}

      <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
        {step > 1 && <Button type="button" onClick={() => setStep(step - 1)}>Nazad</Button>}
  {step < 4 && <Button type="button" onClick={() => setStep(step + 1)}>Dalje</Button>}
  {step === 4 && <Button type="submit">Pošalji</Button>}
      </div>
    </form>
  );
}
